// extracted by mini-css-extract-plugin
export default {"program-detail-item-container":"styles_program-detail-item-container__-n3He"};